import React from "react";
import ReactDOM from "react-dom/client";
import { v4 as uuidv4 } from "uuid";

import StorageManager from "@/features/storage";

import App from "./App";
import { Providers } from "./components/providers";
import "./features/localisation/i18n";
import "./styles/index.css";

if (!StorageManager.getDeviceId()) {
  StorageManager.setDeviceId(uuidv4());
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);
